<template>
  <div
    v-if="init && !search && !conversationList.length"
    layout="column"
    layout-align="start center"
  >
    <div
      layout="row"
      layout-align="start start"
      class="bg-white title search-title full-width pa-2"
    >{{$t('privates.start')}}</div>
    <div class="search-bar search-bar-new full-width">
      <v-menu
        v-model="searching"
        offset-y
        full-width
        max-height="300"
      >
        <v-text-field
          v-model="search2"
          :placeholder="$t('messages.search_recipient')"
          :hide-no-data="(!search2 || search2.length < 3) ? true : false"
          hide-details
          solo
          return-object
          single-line
          :loading="loading"
          flat
          height="20"
          prepend-inner-icon="mdi-magnify"
          slot="activator"
        ></v-text-field>
        <v-list
          v-if="items && items.length"
          class="search-list"
        >
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            @click="handleSelect(item)"
            class="search-item"
          >
            <div
              layout="row"
              layout-align="start center"
              class="body-1"
              style="color: black"
            >
              <avatar
                :fullname="item.firstname + ' ' + item.lastname"
                :image="getImageData(item.id)"
                class="mr-2"
                size="18"
              ></avatar>
              <div layout="column">
                <b>{{item.firstname}} {{item.lastname}}</b>
                {{item.school.name}}
              </div>
            </div>
          </v-list-tile>
        </v-list>
        <div
          v-else-if="!loading && search2 && search2.length > 2"
          class="text-xs-center py-2"
          style="background: #fff"
        >
          <em>{{$t('_.no_result')}}</em>
        </div>
      </v-menu>
    </div>
  </div>
  <div
    v-else
    layout="row"
    full-width
    class="ml-4 mr-4 rp-center"
  >
    <div
      layout="column"
      v-show="!mobileMessageSelected || !checkIfSmallScreen"
      class="conversation-list-container"
    >
      <v-navigation-drawer
        v-model="drawer"
        permanent
        style="width: inherit; height: 100%"
      >
        <div
          layout="column"
          style="height: 100%"
        >
          <v-list
            class="pt-0 convs-list"
            dense
            two-line
          >
            <v-divider></v-divider>
            <div class="mx-3">
              <v-text-field
                clearable
                prepend-inner-icon="mdi-account-search"
                v-model="search"
                :placeholder="$t('privates.search')"
                :loading="searchingConv"
                @input="searchConversation"
                @click:clear="fetchConversations(false)"
              ></v-text-field>
            </div>
            <div
              v-if="!loadingConversations"
              class="conversation-list"
            >
              <v-list-tile
                v-for="(conversation, index) in conversationListFiltered()"
                :key="conversation.id"
                avatar
                @click="fetchSpecificConversation(conversation, index)"
                :class="{'active-tab': conversation && currentConversation && (conversation.user_id == currentConversation.user_id)}"
              >
                <v-list-tile-avatar>
                  <avatar
                    size="20"
                    :fullname="conversation.user.firstname + ' ' + conversation.user.lastname"
                    :image="getImageData(conversation.user.id)"
                    class="ml-3 mr-4"
                  ></avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <div
                      layout="row"
                      layout-align="start center"
                    >
                      {{conversation.user.firstname + ' ' + conversation.user.lastname}}
                      <v-badge
                        v-if="nbPrivate[index]"
                        color="red"
                        overlap
                        class="sidenav-badge"
                      >
                        <span slot="badge">{{nbPrivate[index]}}</span>
                      </v-badge>
                    </div>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{conversation.body}}</v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title>{{conversation.body}}</v-list-tile-sub-title> -->
                </v-list-tile-content>
              </v-list-tile>
            </div>
            <div
              v-else
              layout="column"
              layout-align="center center"
            >
              <v-progress-circular
                indeterminate
                color="secondary"
                size="64"
              ></v-progress-circular>
            </div>
          </v-list>

          <div layout="column">
            <v-btn
              color="secondary"
              @click.stop="dialog2 = true"
            >{{$t('messages.new_private')}}</v-btn>
          </div>
        </div>
      </v-navigation-drawer>
    </div>
    <div
      layout="column"
      layout-align="start start"
      style="width: 100%;"
      :class="{'hidden-sm-and-down': !mobileMessageSelected, 'ml-4': !mobileMessageSelected}"
      class="messages-container"
    >
      <div
        class="rp-header hidden-md-and-up mb-3 bg-white"
        layout="row"
        layout-align="start center"
        v-if="currentConversation && currentConversation.user"
      >
        <v-btn
          flat
          color="secondary"
          class="ma-0 pa-0"
          icon
          @click="mobileMessageSelected = false"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <avatar
          v-if="currentIsMEN && $store.state.men_logo"
          size="20"
          :fullname="currentConversation.user.firstname + ' ' + currentConversation.user.lastname"
          :image="$store.state.men_logo"
        ></avatar>
        <avatar
          v-else
          size="20"
          :fullname="currentConversation.user.firstname + ' ' + currentConversation.user.lastname"
          :image="getImageData(currentConversation.user_id)"
        ></avatar>
        <!-- // ! Correspondent details  -->
        <div class="ml-2">
          <div>
            <b>{{currentName}}</b>
            <v-chip
              label
              :color="levelColor(level)"
              class="text-lowercase ml-2"
              text-color="white"
              style="width: fit-content"
              small
            >{{levelLabel(level)}}</v-chip>
          </div>
          <div class="pb-1">{{currentInfo}}</div>
        </div>
      </div>
      <!-- // ! Conversation Details -->
      <div
        class="messages"
        layout="row"
        layout-align="start start"
      >
        <v-container class="timeline-container pa-0 pl4-pc">
          <div
            v-if="conversationLoading"
            layout="column"
            layout-align="center center"
          >
            <v-progress-circular
              indeterminate
              color="secondary"
              size="64"
            ></v-progress-circular>
          </div>
          <template v-else-if="currentConversation">
            <div
              layout="row"
              layout-align="start center"
              class="bg-white full-width px-3 py-2 mb-2 hidden-sm-and-down"
            >
              <avatar
                v-if="currentIsMEN && $store.state.men_logo"
                size="40"
                :fullname="currentConversation.user.firstname + ' ' + currentConversation.user.lastname"
                :image="$store.state.men_logo"
              ></avatar>
              <avatar
                v-else
                size="40"
                :fullname="currentConversation.user.firstname + ' ' + currentConversation.user.lastname"
                :image="getImageData(currentConversation.user_id)"
              ></avatar>
              <div
                layout="column"
                class="ml-2"
              >
                <div
                  layout="row"
                  layout-align="start center"
                  class="headline"
                >
                  <b>{{currentName}}</b>
                  <v-chip
                    label
                    :color="levelColor(level)"
                    class="text-lowercase ml-2"
                    text-color="white"
                    style="width: fit-content"
                    small
                  >{{levelLabel(level)}}</v-chip>
                </div>
                <div>{{currentInfo}}</div>
              </div>
            </div>
            <div
              layout="column"
              class="pt-0 ti-container"
              id="replies-container"
              style="margin-bottom: 10px"
            >
              <transition-group
                name="list"
                tag="p"
              >
                <div
                  v-for="(reply, i) in currentConversationDetail"
                  :key="reply.id"
                  layout="row"
                  layout-align="start center"
                >
                  <avatar
                    v-if="reply.creator_id == userId"
                    size="20"
                    :fullname="reply.creator.firstname + ' ' + reply.creator.lastname"
                    :image="getImageData(reply.creator.id)"
                    class="mr-2"
                  ></avatar>
                  <span
                    v-else
                    flex
                  />
                  <private-message
                    :ref="'pm_' + reply.id"
                    :message="reply"
                    style="margin-top: 10px; min-width: 55%"
                    @edit="editMessage(reply)"
                    @removed="onDelete(i)"
                    @deleted="onDelete(i)"
                  ></private-message>
                  <avatar
                    v-if="reply.creator_id != userId"
                    size="20"
                    :fullname="reply.creator.firstname + ' ' + reply.creator.lastname"
                    :image="getImageData(reply.creator.id)"
                    class="ml-2"
                  ></avatar>
                </div>
              </transition-group>
            </div>
          </template>
          <v-layout
            v-else-if="!loadingConversations"
            row
            justify-center
            align-center
            class="pulse"
            id="info-arrow"
          >
            <v-icon
              large
              class="mr-3"
              color="secondary"
            >mdi-arrow-left</v-icon>
            <div
              class="subheading"
              color="secondary"
            >{{$t('privates.choose_conv')}}</div>
          </v-layout>
        </v-container>
      </div>
      <!-- // ! Message form -->
      <div
        layout="row"
        layout-align="start start"
        v-if="currentConversation"
        class="message-form bg-white"
      >
        <private-message-form
          @cancel="cancelEdit"
          @save="save"
          ref="messageForm"
          v-model="editingMessage"
          :loading="loading"
          isPrivate
          :class="{'is-editing': startEditing}"
        ></private-message-form>
      </div>
    </div>

    <v-dialog
      v-model="dialog2"
      max-width="430px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card>
        <v-card-title>
          <div
            layout="row"
            layout-align="start center"
            class="full-width"
          ><span class="title">{{$t('messages.new_private')}}</span>
            <span flex></span>
            <v-btn
              icon
              @click="cancel"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="search-bar">
            <v-menu
              v-model="searching"
              offset-y
              full-width
              max-height="300"
              max-width="388"
              class="mr-2"
            >
              <v-text-field
                v-model="search2"
                :placeholder="$t('messages.search_recipient')"
                :hide-no-data="(!search2 || search2.length < 3) ? true : false"
                hide-details
                solo
                return-object
                single-line
                :loading="loading"
                flat
                height="20"
                prepend-inner-icon="mdi-magnify"
                slot="activator"
              ></v-text-field>
              <v-list
                v-if="items && items.length"
                class="search-list"
              >
                <v-list-tile
                  v-for="(item, index) in items"
                  :key="index"
                  @click="handleSelect(item)"
                  class="search-item"
                >
                  <div
                    layout="row"
                    layout-align="start center"
                    class="body-1"
                    style="color: black"
                  >
                    <avatar
                      :fullname="item.firstname + ' ' + item.lastname"
                      :image="getImageData(item.id)"
                      class="mr-2"
                      size="18"
                    ></avatar>
                    <div layout="column">
                      <b>{{item.firstname}} {{item.lastname}}</b>
                      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{item.school.name}}</div>
                    </div>
                  </div>
                </v-list-tile>
              </v-list>
              <div
                v-else-if="!loading && search2 && search2.length > 2"
                class="text-xs-center py-2"
                style="background: #fff"
              >
                <em>{{$t('_.no_result')}}</em>
              </div>
            </v-menu>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Messages from "@/api/messages"
import Conversations from "@/api/conversations"
import Avatar from "@/components/shared/Avatar"
import ImageMixin from "@/mixins/image"
import Auth from "@/plugins/auth"
import PrivateMessageForm from "@/components/shared/PrivateMessageForm.vue"
import Consts from "@/consts"
import FormDataMixin from "@/mixins/formdata"
import PrivateMessage from "@/components/shared/PrivateMessage.vue"
import I18nMixin from "@/mixins/i18n"
import EventBus from "@/plugins/eventbus"
import Representatives from "@/api/representatives"

export default {
  components: { Avatar, PrivateMessageForm, PrivateMessage },
  mixins: [ImageMixin, FormDataMixin, I18nMixin],

  data () {
    return {
      drawer: true,
      right: null,
      events: [],
      input: null,
      nonce: 0,
      conversationList: [],
      imgs: {},
      imgsLoad: {},
      currentConversation: null,
      currentConversationDetail: [],
      search: "",
      isEditingMessage: false,
      isEditingEvent: false,
      filters: {
        sortBy: "published_at",
        ascending: 1,
      },
      loading: false,
      editingMessage: {
        type: "",
        body: "",
        levels_ids: [],
        sectors_ids: [],
        schools_ids: [],
        regional_directorates_ids: [],
        regions_ids: [],
        cities_ids: [],
        circles_ids: [],
        date_start: null,
        creator: {},
      },
      conversationLoading: false,
      dialog2: false,
      search2: "",
      items: [],
      searching: false,
      nbPrivate: [],
      mobileMessageSelected: false,
      loadingConversations: true,
      init: false,
      searchingConv: false,
      startEditing: false
    }
  },
  computed: {
    isAdmin () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
    timeline () {
      return this.events.slice().reverse()
    },
    userId () {
      return Auth.user.id
    },
    userFName () {
      return Auth.user.firstname
    },
    userLName () {
      return Auth.user.lastname
    },
    checkIfSmallScreen () {
      return this.$vuetify.breakpoint.smAndDown
    },
    level () {
      return this.currentConversation.user.level
    },
    currentIsMEN () {
      if (this.currentConversation && this.currentConversation.user && this.currentConversation.user.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
    currentIsDeleted () {
      if (this.currentConversation && this.currentConversation.user && this.currentConversation.user.is_deleted) {
        return true
      }
      return false
    },
    currentName () {
      if (!this.currentConversation || !this.currentConversation.user) {
        return ""
      }

      let r = ""
      if (this.currentIsMEN) {
        r += this.$t("_.the") + " MEN"
      } else if (this.currentIsDeleted) {
        r += this.$t("users.inactive")
      } else {
        r += this.currentConversation.user.firstname + ' ' + this.currentConversation.user.lastname
      }
      return r
    },
    currentInfo () {
      if (!this.currentConversation || !this.currentConversation.user) {
        return ""
      }

      let r = ""
      if (!this.currentIsMEN && this.currentConversation.user.school && this.currentConversation.user.school.name) {
        r += this.currentConversation.user.school.name
      } else if (this.currentIsMEN && this.isAdmin) {
        r += this.currentConversation.user.firstname + ' ' + this.currentConversation.user.lastname
      }
      return r
    }
  },
  mounted () {
    this.loadProfilePicture()
    this.fetchConversations()
    this.$store.commit("LOAD_LOGO")

    this.$nextTick(() => {
      EventBus.$on("new-private", () => (this.fetchConversations(true)))
    })
  },
  destroyed () {
    EventBus.$off("new-private")
  },
  watch: {
    search2 (val) {
      val && val !== this.querySearchAsync(val)
    },
  },
  methods: {
    conversationListFiltered () {
      if (this.search) {
        return this.conversationList
      } else {
        let unfiltered = this.conversationList
        unfiltered.forEach((element, index) => {
          this.nbPrivate[index] = element.nb_unread
        })
        return unfiltered
      }
    },
    cancel () {
      this.dialog2 = false
      this.searching = false
      this.search2 = ''
      this.items = []
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t("users.lv_min")
        case Consts.NATIONAL:
          return this.$t("users.lv_nat")
        case Consts.SECTORAL:
          return this.$t("users.lv_sec")
        case Consts.LOCAL:
          return this.$t("users.lv_loc")
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return "primary"
        case Consts.NATIONAL:
          return "pink"
        case Consts.SECTORAL:
          return "secondary"
        case Consts.LOCAL:
          return "brown"
      }
    },
    searchConversation (search) {
      if (search && (search.length > 0) && (search.length < 3)) {
        return
      }

      this.searchingConv = true

      Conversations.getAllConversations({ keywords: search }).then((res) => {
        this.conversationList = res.data

        this.conversationList.forEach((conversation) => {
          this.getImage(
            "/assets/users/" + conversation.user_id,
            conversation.user_id
          )
        })

        this.searchingConv = false
      })
    },
    refreshCurrent () {
      if (Auth.user.last_recipient_id) {
        for (let i = 0; i < this.conversationList.length; i++) {
          if (this.conversationList[i].user_id === Auth.user.last_recipient_id) {
            this.fetchSpecificConversation(this.conversationList[i], i)
            break
          }
        }
      }
    },
    fetchConversations (refresh = false) {
      Conversations.getAllConversations().then((res) => {
        this.conversationList = res.data

        if (!this.init) {
          if (this.$route.params.newMessage) {
            this.handleSelect(this.$route.params.newMessage)
          } else {
            this.refreshCurrent()
          }
        } else if (refresh) {
          for (let i = 0; i < this.conversationList.length; i++) {
            const c = this.conversationList[i]
            if (c.nb_unread && (c.user_id === this.currentConversation.user_id) && (c.nb_unread != this.currentConversation.nb_unread)) {
              this.refreshCurrent()
            }
          }
        }

        this.conversationList.forEach((conversation) => {
          this.getImage(
            "/assets/users/" + conversation.user_id,
            conversation.user_id
          )
        })

        this.loadingConversations = false
        this.init = true
      })
    },
    fetchSpecificConversation (conversation, index) {
      this.conversationLoading = true
      this.mobileMessageSelected = this.checkIfSmallScreen

      Conversations.getSpecificConversation(conversation.user_id, this.filters).then(
        (res) => {
          this.currentConversationDetail = res.data
          this.currentConversation = conversation
          window.setTimeout(
            function () {
              if (this.checkIfSmallScreen) {
                const elem = this.$el.querySelector(".messages")
                elem.scrollTop = elem.scrollHeight
              } else {
                const elem = this.$el.querySelector(".ti-container")
                elem.scrollTop = elem.scrollHeight
              }
            }.bind(this),
            500
          )
          this.conversationLoading = false
          this.nbPrivate[index] = 0
          EventBus.$emit("privates-update")

          Auth.user.last_recipient_id = conversation.user_id
          localStorage.setItem('user', JSON.stringify(Auth.user))
        }
      )
    },
    loadProfilePicture () {
      this.imgs = {}
      this.imgsLoad = {}
      if (Auth.user && Auth.user.avatar_id) {
        this.getImage("/assets/users/" + Auth.user.id, Auth.user.id)
      }
    },
    cancelEdit () {
      this.resetMessage()
      this.loading = false
      this.isEditingMessage = false
      this.isEditingEvent = false
      this.editDialog = false
      this.messageDialog = false
      this.search = ""
      this.search2 = ""
      this.items = []
      this.$refs.messageForm.reset()
    },
    save (data) {
      if (!this.$refs.messageForm.$refs.form.validate()) {
        return
      }

      this.loading = true

      if (this.currentConversation.recipient_id === this.userId) {
        this.editingMessage.recipient_id = this.currentConversation.creator_id
      } else {
        this.editingMessage.recipient_id = this.currentConversation.recipient_id
      }
      // Convert the data to FormData for proper file upload
      let formData = new FormData()
      let o = Object.assign(
        {},
        this.editingMessage,
        { deleted_medias: data.deletedMedias },
        { deleted_docs: data.deletedDocs }
      )
      this._convertObjectToFormData(formData, o)

      if (data.banner && data.banner != {} && data.banner instanceof Blob) {
        formData.append("banner", data.banner, data.banner.name)
      }

      for (let i = 0; i < data.medias.length; i++) {
        if (!data.medias[i].id) {
          formData.append(
            "medias[" + i + "]",
            data.medias[i],
            data.medias[i].name
          )
        }
      }

      for (let i = 0; i < data.documents.length; i++) {
        if (!data.documents[i].id) {
          formData.append(
            "documents[" + i + "]",
            data.documents[i],
            data.documents[i].name
          )
        }
      }

      if (!this.editingMessage.id) {
        Messages.create(formData).then(
          res => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.isEditingEvent = false
            this.editDialog = false
            this.messageDialog = false
            this.search = ""
            this.search2 = ""
            this.items = []
            this.$snotify.success(this.$t("messages.created"))
            this.$refs.messageForm.reset()

            if (!this.currentConversationDetail || !this.currentConversationDetail.length) {
              this.fetchSpecificConversation(this.currentConversation)
            } else {
              this.currentConversationDetail.push(res.data)

              setTimeout(() => {
                let objDiv = document.getElementById("replies-container")
                objDiv.scrollTop = objDiv.scrollHeight
              }, 300)
            }
          },
          () => {
            this.loading = false
          }
        )
      } else {
        Messages.updateAsForm(this.editingMessage.id, formData).then(
          res => {
            this.loading = false
            for (let i = 0; i < this.currentConversationDetail.length; i++) {
              if (this.currentConversationDetail[i].id === this.editingMessage.id) {
                this.currentConversationDetail.splice(i, 1, res.data)
                this.currentConversationDetail[i].id = 'new'

                this.$nextTick(() => {
                  this.currentConversationDetail[i].id = this.editingMessage.id
                  this.currentConversationDetail[i] = Object.assign({}, this.currentConversationDetail[i])

                  this.resetMessage()
                  this.isEditingMessage = false
                  this.isEditingEvent = false
                  this.editDialog = false
                  this.messageDialog = false
                  this.search = ""
                  this.search2 = ""
                  this.items = []
                  this.$snotify.success(this.$t("messages.edited"))
                  this.$refs.messageForm.reset()
                })
                break
              }
            }
          },
          () => {
            this.loading = false
          }
        )
      }
    },
    resetMessage () {
      this.$refs.messageForm.$refs.form.reset()
      this.defaultMessage()
    },
    defaultMessage () {
      this.editingMessage = Object.assign(
        {},
        {
          type: "",
          body: "",
          levels_ids: [],
          sectors_ids: [],
          schools_ids: [],
          regional_directorates_ids: [],
          regions_ids: [],
          cities_ids: [],
          circles_ids: [],
          date_start: null,
        }
      )
    },
    onDelete () {
      this.fetchSpecificConversation(this.currentConversation)
    },
    editMessage (m) {
      this.startEditing = true
      this.defaultMessage()
      this.editingMessage = JSON.parse(JSON.stringify(m))

      this.isEditingMessage = true
      let a = document.createElement("a")
      document.body.appendChild(a)
      a.style = "display: none"
      a.href = "#message-form"
      a.click()

      this.editingMessage.levels_ids = []
      this.editingMessage.sectors_ids = []
      this.editingMessage.regional_directorates_ids = []
      this.editingMessage.regions_ids = []
      this.editingMessage.cities_ids = []
      this.editingMessage.schools_ids = []
      this.editingMessage.circles_ids = []

      for (
        let i = 0;
        i < this.editingMessage.regional_directorates.length;
        i++
      ) {
        this.editingMessage.regional_directorates_ids.push(
          this.editingMessage.regional_directorates[i].id
        )
      }

      for (let i = 0; i < this.editingMessage.regions.length; i++) {
        this.editingMessage.regions_ids.push(this.editingMessage.regions[i].id)
      }

      for (let i = 0; i < this.editingMessage.schools.length; i++) {
        this.editingMessage.schools_ids.push(this.editingMessage.schools[i].id)
      }

      for (let i = 0; i < this.editingMessage.levels.length; i++) {
        this.editingMessage.levels_ids.push(
          this.editingMessage.levels[i].level
        )
      }

      for (let i = 0; i < this.editingMessage.sectors.length; i++) {
        this.editingMessage.sectors_ids.push(
          this.editingMessage.sectors[i].sector
        )
      }

      for (let i = 0; i < this.editingMessage.cities.length; i++) {
        this.editingMessage.cities_ids.push(this.editingMessage.cities[i].id)
      }

      setTimeout(() => {
        this.startEditing = false
      }, 300)
    },
    querySearchAsync (queryString) {
      if (!queryString || queryString.length < 3) {
        return
      }

      this.loading = true
      this.searching = true

      // cancel pending call
      clearTimeout(this._timerId)

      // delay new call 350ms
      this._timerId = setTimeout(() => {
        Representatives.getList({ keywords: queryString, is_enabled: 1 }).then((res) => {
          this.items = res.data
          this.loading = false
          // this.search2 = queryString

          for (let i = 0; i < this.items.length; i++) {
            const r = this.items[i]

            if (r.avatar_id) {
              this.getImage(
                "/assets/users/" + r.id,
                r.id
              )
            }
          }
        })
      }, 350)
    },
    typeIcon (t) {
      switch (t) {
        case Consts.EVENT:
          return "calendar"
        case Consts.SURVEY:
          return "clipboard-text"
        case Consts.CIRCLE:
          return "set-none"
        case Consts.PLATFORM:
          return "send"
        case Consts.TOPDOWN:
          return "arrow-expand-down"
        case Consts.BOTTOMUP:
          return "arrow-expand-up"
        case Consts.HORIZONTAL:
          return "arrow-expand-horizontal"
      }
    },
    isCurrent (m) {
      if (m.origin) {
        if (Auth.user.id == m.origin.creator_id) {
          return true
        }
      } else {
        if (Auth.user.id == m.creator_id) {
          return true
        }
      }
      return false
    },
    createdAt (m) {
      if (m.origin) {
        return (
          this.formatDateI18n(m.origin.created_at) +
          " " +
          this.$t("_.at") +
          " " +
          this.formatHour(m.origin.created_at)
        )
      } else {
        return (
          this.formatDateI18n(m.created_at) +
          " " +
          this.$t("_.at") +
          " " +
          this.formatHour(m.created_at)
        )
      }
    },
    handleSelect (val) {
      if (val) {
        const newConv = {
          recipient_id: val.id,
          user_id: val.id,
          user: val,
        }

        let found = false
        for (let i = 0; i < this.conversationList.length; i++) {
          if (this.conversationList[i].user_id == val.id) {
            found = i
            break
          }
        }

        if (found === false) {
          this.conversationList.push(newConv)
          this.currentConversationDetail = []
          this.currentConversation = newConv
          window.setTimeout(
            function () {
              if (this.checkIfSmallScreen) {
                const elem = this.$el.querySelector(".messages")
                elem.scrollTop = elem.scrollHeight
              } else {
                const elem = this.$el.querySelector(".ti-container")
                elem.scrollTop = elem.scrollHeight
              }
            }.bind(this),
            500)
        } else {
          this.fetchSpecificConversation(newConv, found)
        }

        this.dialog2 = false
        this.search2 = ''
        this.items = []
      }
    },
  },
};
</script>

<style scoped>
.is-editing {
  background: linear-gradient(-90deg, #2e3b7f, #589c8f);
  transition: background 6s ease;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

@media screen and (min-width: 960px) {
  .search-bar-new,
  .search-title {
    width: 600px;
  }
}

.search-bar .v-input {
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.messages-container {
  height: calc(100vh - 70px);
  max-height: calc(100vh - 70px);
}
.conversation-list-container {
  width: 30rem;
  height: calc(100vh - 70px);
  max-height: calc(100vh - 70px);
}
.conversation-list {
  overflow-y: auto;
  max-height: calc(100% - 44px);
  height: calc(100% - 44px);
  /*height: 100%;*/
}
.convs-list {
  max-height: calc(100% - 48px);
  height: calc(100% - 48px);
}

.messages {
  width: 100%;
  overflow-x: hidden; /* Hide horizontal scrollbar */
  overflow-y: scroll; /* Add vertical scrollbar */
  height: 80vh;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.messages::-webkit-scrollbar {
  display: none;
}

@media screen and (min-width: 960px) {
  .conversation-list-container {
    height: calc(100vh - 166px);
    max-height: calc(100vh - 166px);
  }
  .messages-container {
    height: calc(100vh - 166px);
    max-height: calc(100vh - 166px);
  }
  .messages {
    height: calc(100% - 226px);
    max-height: calc(100% - 226px);
  }
  .ti-container {
    height: calc(100% - 96px);
    max-height: calc(100% - 96px);
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  /* Hide scrollbar for Chrome, Safari and Opera */
  .ti-container::-webkit-scrollbar {
    display: none;
  }
}

.active-tab {
  border-left: 4px solid #589c8f;
  background-color: #e8f8f7;
}

.test {
  margin: 1rem 1rem;
}

.pulse {
  width: max-content;
  animation: pulse 2s ease-in infinite;
}

.rp-limit-height {
  height: 95%;
}

.message-form {
  width: 100%;
}

#info-arrow > span {
  transform: translate(0, -50%);
}

.timeline-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

.rp-header {
  display: flex;
  width: 100%;
}

@keyframes pulse {
  25% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

@media only screen and (max-width: 1264px) {
  .rp-center {
    justify-content: center;
    margin: 0 auto;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .rp-limit-height {
    height: 90%;
  }
  .messages {
    max-height: 57vh;
  }
  /*.conversation-list {
    height: 60vh;
  }*/
  .conversation-list-container {
    width: 100%;
  }
  .message-form {
    overflow: hidden;
    margin: auto;
  }
  /*.v-timeline::before {
    display: none;
  }*/
  .v-timeline-item {
    padding-bottom: 0;
  }
}
</style>

<style>
@media only screen and (max-width: 1264px) {
  .v-timeline--dense .v-timeline-item__body {
    /*max-width: 100% !important;*/
    max-width: calc(100% - 50px);
  }
}
.v-timeline:before {
  height: 0;
}
.search-list > div:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.05);
}
.search-item > a {
  height: 55px;
}
</style>